import React from "react";
import { cn } from "@/lib/utils";

interface SectionBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
}

// Reusable rounded badge used for section labels (e.g. "Value Proposition")
export default function SectionBadge({
  text,
  className,
  ...rest
}: SectionBadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full border border-white/20 text-white font-host-grotesk tracking-tight",
        // custom paddings per spec: px 2.375rem, py 1.375rem
        "px-9.5 py-5.5 text-sm md:text-[1.125rem] ",
        className,
      )}
      {...rest}
    >
      {text}
    </div>
  );
}
